export default {
  meta: {
    title: 'How Do You Recycle?',
    titleSuffix: 'How Do You Recycle?',
    description: `Answers to all of your 'how do you recycle' questions - get advice on recycling all materials, and learn how they're recycled after they leave your home`,
    keywords: `recycling recycle`
  },
  googleTagManagerId: 'G-EZDX5NHWE0'
};